module.exports = __webpack_public_path__ + "img/safetyImg7.e6b97305.png";